import { useMemo } from "react";
import AuthWrapper from "../components/Auth/AuthWrapper";
import useUserAuth from "./hooks/useUserAuth";
import { AuthContext } from "./AuthContext";
import { TokenMonitor } from "./TokenMonitor";

const { Provider } = AuthContext;

export const AuthProvider = ({ children }) => {
    const {
        isAuthenticated, isAuthenticating, showErrorPage,
        azureUser, azureAccessToken,
        apiUser, apiAccessToken, logOut,
    } = useUserAuth();
    const isAuthError = !isAuthenticated && !isAuthenticating;

    const value = useMemo(() => ({
        userId: apiUser?.PG,
        apiAccessToken,
        apiUser,
        azureAccessToken,
        azureUser,
        isAuthenticated,
        logOut,
    }), [apiAccessToken, apiUser, azureAccessToken, azureUser, isAuthenticated, logOut]);

    if (!isAuthenticated || isAuthenticating || showErrorPage) {
        return (
            <AuthWrapper
                isAuthError={isAuthError}
                showErrorPage={showErrorPage}
                isAuthenticated={isAuthenticated}
                isAuthenticating={isAuthenticating}
                logOut={logOut}
            />
        );
    }

    return (
        <Provider value={value}>
            <TokenMonitor logOut={logOut}>
                {children}
            </TokenMonitor>
        </Provider>
    );
};
